import { FrozenDarkTheme } from "../.internal/themes/FrozenDarkTheme";
export default FrozenDarkTheme;
